var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71492 8.00004C6.2801 8.00004 6.83259 7.83243 7.30252 7.51842C7.77244 7.20442 8.13869 6.75811 8.35496 6.23594C8.57122 5.71377 8.62778 5.1392 8.51748 4.58488C8.40718 4.03057 8.13498 3.52141 7.7353 3.1218C7.33562 2.72219 6.82642 2.45008 6.27209 2.33988C5.71775 2.22968 5.14319 2.28634 4.62106 2.50269C4.09893 2.71905 3.65268 3.08538 3.33875 3.55536C3.02483 4.02534 2.85732 4.57785 2.85742 5.14304C2.85822 5.9006 3.15954 6.6269 3.69527 7.16254C4.231 7.69817 4.95736 7.99937 5.71492 8.00004Z",
    fill: "#821C6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4525 10.3605C8.72841 9.61784 7.79936 9.10784 6.78402 8.89569C5.76869 8.68354 4.71316 8.77887 3.75226 9.16951C2.79136 9.56014 1.96873 10.2284 1.38943 11.0888C0.81013 11.9492 0.500469 12.9628 0.5 14C0.5 14.1327 0.552678 14.2598 0.646447 14.3536C0.740215 14.4474 0.867392 14.5 1 14.5H10.43C10.5626 14.5 10.6898 14.4474 10.7836 14.3536C10.8773 14.2598 10.93 14.1327 10.93 14C10.9319 13.4699 10.8501 12.9427 10.6875 12.438C10.4454 11.6579 10.0222 10.946 9.4525 10.3605Z",
    fill: "#821C6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.25C12.9236 8.25 13.875 7.2986 13.875 6.125C13.875 4.95139 12.9236 4 11.75 4C10.5764 4 9.625 4.95139 9.625 6.125C9.625 7.2986 10.5764 8.25 11.75 8.25Z",
    fill: "#821C6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7497 8.83496C11.0795 8.83748 10.4222 9.02001 9.84668 9.36346C9.95518 9.46046 10.0647 9.55596 10.1672 9.66096C10.848 10.3607 11.3537 11.2115 11.6432 12.144C11.7423 12.4509 11.8154 12.7657 11.8617 13.085H14.9997C15.1323 13.085 15.2595 13.0323 15.3532 12.9385C15.447 12.8447 15.4997 12.7176 15.4997 12.585C15.4986 11.5907 15.1032 10.6375 14.4002 9.93448C13.6971 9.23145 12.7439 8.83602 11.7497 8.83496Z",
    fill: "#821C6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserSmall);
export default __webpack_public_path__ + "static/media/ic-user-small.f17798368bafbe1963de9aa09222efb3.svg";
export { ForwardRef as ReactComponent };